import { Component, inject, OnDestroy } from '@angular/core';
import { CommandResult } from '@cl/shared/models';
import { FileMetadata } from '@cl/shared/models/file.model';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-file-preview-modal',
    standalone: false,
    templateUrl: './file-preview-modal.component.html',
    styleUrl: './file-preview-modal.component.less',
})
export class FilePreviewModalComponent implements OnDestroy {
    readonly previewData: {
        fileName: string;
        loadFileMetadata: () => Promise<CommandResult<FileMetadata>>;
        downloadFile: () => Promise<void>;
    } = inject(NZ_MODAL_DATA);

    expanded = false;
    downloadLoading = false;
    downloadErrors: string[] = [];
    private sequence = 0;

    constructor(private modal: NzModalRef) {}

    ngOnDestroy(): void {
        this.sequence++;
    }

    close(): void {
        this.sequence++;
        this.modal.destroy();
    }

    toggleExpanded(): void {
        this.expanded = !this.expanded;
        this.modal.updateConfig({
            nzWidth: this.expanded ? '98%' : '90%',
            nzStyle: { top: this.expanded ? '0.5rem' : '1rem', paddingBottom: this.expanded ? '0' : '1.5rem' },
        });
    }

    async download(): Promise<void> {
        const sequence = this.sequence;
        this.downloadLoading = true;
        this.downloadErrors = [];
        try {
            await this.previewData.downloadFile();
        } catch (error: any) {
            if (sequence === this.sequence) {
                this.downloadErrors = this.errors(error, 'Failu neizdevās lejupielādēt.');
            }
        } finally {
            if (sequence === this.sequence) {
                this.downloadLoading = false;
            }
        }
    }

    private errors(error: any, fallback: string): string[] {
        const errors = error.error?.errors;
        return Array.isArray(errors) && errors.length
            ? errors.map((message: any) => (typeof message === 'string' ? message : message.error || fallback))
            : [fallback];
    }
}
